module.exports = __webpack_public_path__ + "static/media/icon-info-inactive.aa1499c7.svg";